// https://www.colorhexa.com/171c22
// https://chir.ag/projects/name-that-color/#173143
// https://simplecss.eu/rgbatohex.html

const COLORS = {
  white: "#fff",
  white8: "rgba(255,255,255,0.8)",
  bigStone: "#6164a6",
  ebb: "#edebe9",
  scampi: "#6364a7",
  eastBay: "#464775",
  kimberly: "#696c99",
  gallery: "#ebebeb",
  gallery1: "#f0f0f0",
  desertStorm: "#f3f2f1",
  dustyGray: "#999",
  boulder: "#797979",
  alto: "#d1d1d1",
  alto1: "#d6d6d6",
  silverChalice: "#9d9d9d",
  silverChalice1: "#adadad",
  silverChalice3: "#b2b2b2",
  dustyGray: "#949494",
  gray: "#787878",
  codGray: "#0a0a0a",
  mineShaft: "#1f1f1f",
  mineShaft1: "#141414",
  mineShaft2: "#292929",
  mineShaft3: "#3d3d3d",
  mineShaft4: "#201f1f",
  yellow: "#ffff00",
  blue: "#18ebff",
  melrose: "#9ea2ff",
};

export default COLORS;
